function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { CSSProperties, Ref, FC, useState, useEffect, useCallback, AnimationEvent, MouseEvent, ReactElement, ReactNode } from 'react';
import cn from 'classnames';
import { Title } from '../Title';
import { Typography } from '../Typography';
import { Icon } from '../Icon';
require("./Notification.css");
var styles = {
  "Root": "Notification-module-Root_E_a",
  "slideInUpAnimation": "Notification-module-slideInUpAnimation_3Nv",
  "slideInUp": "Notification-module-slideInUp_12k",
  "slideInDown": "Notification-module-slideInDown_1XQ",
  "dissolveAnimation": "Notification-module-dissolveAnimation_5Pa",
  "dissolve": "Notification-module-dissolve_2Hr",
  "Title": "Notification-module-Title_1NJ",
  "Text": "Notification-module-Text_2Xj",
  "AddonBottom": "Notification-module-AddonBottom_3pN",
  "Btn": "Notification-module-Btn_20v",
  "Close": "Notification-module-Close_307",
  "AddonBefore": "Notification-module-AddonBefore_t6d"
};
export const NotificationVariants = {
  light: 'light',
  dark: 'dark'
};
export const Notification = ({
  className,
  title = '',
  message = '',
  style = {},
  innerRef,
  controlRef,
  action = null,
  showNext = null,
  isTemporary = false,
  timer = 15000,
  id,
  addonBefore,
  addonBottom,
  variant = NotificationVariants.light,
  ...props
}) => {
  const [animation, setAnimation] = useState('');
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimation('slideInUp');
    }, 100);
    return () => clearTimeout(timer);
  }, [setAnimation]);
  useEffect(() => {
    if (isTemporary) {
      const timerRemoveNotification = setTimeout(() => {
        setAnimation('dissolve');
      }, timer);
      return () => clearTimeout(timerRemoveNotification);
    }
    return;
  }, [setAnimation, isTemporary, timer]);
  const handleClose = useCallback(e => {
    setAnimation('dissolve');
    if (action !== null) {
      e.preventDefault();
      action();
    }
    if (showNext !== null) {
      showNext();
      setAnimation('slideInUp');
    }
  }, [action, showNext]);
  const handleClosedAnimation = useCallback(e => {
    if (e.animationName.indexOf('dissolve') !== -1) {
      setShow(false);
    }
  }, []);
  return show ? /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.Root, styles[`${animation}Animation`], className),
    ref: innerRef || controlRef,
    style: style,
    onAnimationEnd: handleClosedAnimation,
    "data-id": id,
    "data-variant": variant,
    role: "alert"
  }, props), addonBefore && /*#__PURE__*/React.createElement("div", {
    className: styles.AddonBefore
  }, addonBefore), title && /*#__PURE__*/React.createElement(Title, {
    tag: "h4",
    className: styles.Title
  }, title), message && /*#__PURE__*/React.createElement(Typography, {
    variant: "p2",
    className: styles.Text
  }, message), addonBottom && /*#__PURE__*/React.createElement("div", {
    className: styles.AddonBottom
  }, addonBottom), /*#__PURE__*/React.createElement("button", {
    className: styles.Close,
    onClick: handleClose,
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: 'close',
    size: "m"
  }))) : null;
};
if (process.env.NODE_ENV !== 'production') {
  Notification.displayName = 'Notification';
}